import { render, staticRenderFns } from "./GraficoResultsTournament.vue?vue&type=template&id=4a585c7e"
import script from "./GraficoResultsTournament.vue?vue&type=script&lang=js"
export * from "./GraficoResultsTournament.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports